<div class="header">
    <div class="container">
        <div class="row flmid headercnt">
            <div class="col-auto mOrder1">
            <a  href="{{logoUrlLink}}" target="_blank" rel="noopener" class="logo-brand">
                <img class="headerImage" id="mainHeaderLogo"   alt="Logo" />
            </a>
            </div>
            <div class="col-auto mOrder3 mblock mr-auto">
                    <app-sub-header></app-sub-header>
            </div>
            <div *ngIf="!isProd" class="d-flex align-items-center text-danger" translate>
              lblTestingEnvironment
            </div>
            <div class="lang-dropdown col-auto ml-auto mOrder2" *ngIf="isLanguageFlag">
                <ng-select [items]="languageModel" bindLabel="value" bindValue="key" (change)="ChangeLanguage($event.key)"
                    [(ngModel)]="currentLang" [clearable]="false" [searchable]="false" ngDefaultControl>
                    <ng-template ng-label-tmp let-item="item">
                        <img height="15" [src]="getFlagImage(item.flagName)" alt="" />
                        <strong class="lang">{{item.value}}</strong>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <img height="15" [src]="getFlagImage(item.flagName)" alt="" />
                        <strong class="lang">{{item.value}}</strong>
                    </ng-template>

                </ng-select>
            </div>
        </div>

    </div>
</div>
